import { Identifiable, Project } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";
import { formatDate } from "../utils/formatDate";

function validateTimeRecords(httpClient: HttpClient) {
  return (project: Identifiable<Project>, date: string) => {
    const d = new Date(date);

    return httpClient.sendHttpRequest<void>({
      endpoint: `/projects/${project.uuid}`,
      method: HttpMethods.PATCH,
      data: {
        integratedAt: new Date(
          Date.UTC(
            d.getUTCFullYear(),
            d.getUTCMonth(),
            d.getUTCDate(),
            23,
            59,
            59,
          ),
        ).toISOString(),
      },
    });
  };
}

export { validateTimeRecords };
